import { setNotification } from "../store/slice/miscSlice";
import { useCallback } from "react";
import { useDispatch } from "react-redux";

/**
 * Custom hook to dispatch notifications.
 *
 * Pass `actions` to show follow-up links under the message, e.g.
 * `[{ label: "Open order", to: "/sales/order/12" }]`.
 *
 * @returns {Function} - A callback function that dispatches notifications.
 */
export const useNotification = () => {
  const dispatch = useDispatch();
  const notify = useCallback(
    ({ type, message, position, actions }) =>
      dispatch(setNotification({ type, message, position, actions })),
    [dispatch],
  );

  return notify;
};
